import type * as H from "history";
import type { FromLocationState } from "./types";

export function createFromLocationState(from: H.Location): FromLocationState {
    return { from };
}
